import styled from 'foundations-theming/utils';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { H1 } from 'foundations-components/transitional/components/H1';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { View } from 'foundations-components/transitional/components/View';
import { theme, useMediaQuery } from 'academy-common-lib/utils/Styling';
// @ts-expect-error img
import blobsImageUrl from 'bender-url!../../../../images/header-blobs.svg';
import ErrorBoundary from '../../../components/ErrorBoundary';
import { getMarketingThemePreference } from 'academy-common-lib/features/publicTheme/themeUtils';
import { Tag } from 'foundations-components/transitional/components/Tag';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Header = styled.header.withConfig({
  displayName: "PublicPageHeader__Header",
  componentId: "axa9aa-0"
})(({
  theme: {
    color
  }
}) => ({
  background: `url(${blobsImageUrl}) center center no-repeat,
  linear-gradient(
    to right,
    ${color['fill-accent-teal-pressed']},
    ${color['fill-accent-teal-default']}
  )`,
  backgroundSize: ' auto 100%'
}));
const MarketingHeader = props => {
  return /*#__PURE__*/_jsx(View, Object.assign({
    backgroundColor: 'fill-surface-recessed',
    color: "text-core-default"
  }, props));
};
const PublicPageHeader = ({
  badgeText,
  heading,
  description,
  rightContent,
  children
}) => {
  const {
    isDesktop
  } = useMediaQuery('desktop');
  const isMarketingThemeEnabled = getMarketingThemePreference();
  const HeaderComponent = isMarketingThemeEnabled ? MarketingHeader : Header;
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    children: /*#__PURE__*/_jsx(HeaderComponent, {
      children: /*#__PURE__*/_jsx(View, {
        backgroundColor: 'fill-transparent-default',
        color: !isMarketingThemeEnabled ? 'text-core-on-fill-default' : undefined,
        paddingBlock: "1000",
        paddingInline: "400",
        textAlign: "center",
        children: /*#__PURE__*/_jsxs(View, {
          marginBlock: "0",
          marginInline: "auto",
          maxInlineSize: theme.sizes.GRID_BREAKPOINT_MEDIUM,
          position: "relative",
          children: [badgeText && (isMarketingThemeEnabled ? /*#__PURE__*/_jsx(Tag, {
            marginBlockEnd: "600",
            children: badgeText
          }) : /*#__PURE__*/_jsx(Badge, {
            marginBlockEnd: "600",
            use: "koala",
            children: badgeText
          })), heading && /*#__PURE__*/_jsx(H1, {
            children: heading
          }), description && /*#__PURE__*/_jsx(Paragraph, {
            typography: "body-200",
            children: description
          }), children, rightContent && /*#__PURE__*/_jsx(View, {
            inlineSize: "fit-content",
            insetBlockEnd: "0",
            insetInlineEnd: "-220px",
            marginBlock: "0",
            marginInline: "auto",
            maxInlineSize: "160px",
            position: isDesktop ? 'absolute' : 'static',
            children: rightContent
          })]
        })
      })
    })
  });
};
export default PublicPageHeader;